import { combineReducers } from 'redux'

import clubCard from './club-card/duck/reducers'
import digitalStylist from './digital-stylist/duck/reducers'
import donateVoucher from './donate-voucher/duck/reducers'
import hmPay from './hm-pay/duck/reducers'
import hub from './hub/duck/reducers'
import inbox from './inbox/duck/reducers'
import iafContent from './invite-friend/duck/reducers'
import clubRewards from './my-rewards/duck/reducers'
import membershipInfo from './new-member-card/duck/reducers'
import news from './news/duck/reducers'
import pointsHistoryLegacy from './points-history-legacy/duck/reducers'
import pointsHistory from './points-history/duck/reducers'
import purchases from './purchases/duck/reducers'
import AccountState from './types'
import upgradeToClub from './upgrade-to-club/duck/reducers'
import userMenu from './user-menu/duck/reducers'

export default combineReducers<AccountState>({
  clubCard,
  clubRewards,
  hmPay,
  hub,
  inbox,
  purchases,
  upgradeToClub,
  userMenu,
  pointsHistoryLegacy,
  pointsHistory,
  digitalStylist,
  donateVoucher,
  news,
  iafContent,
  membershipInfo,
})
